// extracted by mini-css-extract-plugin
export var content = "_vl-1";
export var wrapper = "_vl-0";